var SimpleCover    = require("app/ui/covers/SimpleCover"),
    get            = require("object-path").get,
    kind           = require("enyo/kind"),
    onHyperlinkTap = require("app/utils/onHyperlinkTap"),
    quickMacroize  = require("enyo/macroize").quickMacroize;

module.exports = kind(/** @lends  app.ui.covers.ExternalCover.prototype */ {

    /**
     * @private
     */
    name: "app.ui.covers.ExternalCover",

    /**
     * @private
     */
    kind: SimpleCover,

    /**
     * @private
     */
    classes: "app-ui-covers-external-cover",

    /**
     * @type     {string}
     * @default  "_blank"
     * @public
     */
    target: "_blank",

    /**
     * @type     {string}
     * @default  "nofollow"
     * @public
     */
    rel: "nofollow",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: kind.inherit(function(sup) {
        return function() {
            var i18nService   = this.app.$.i18nService,
                data          = this.data || {},
                title         = get(data, "meta.title", null) || "",
                $imageWrapper = this.$.imageWrapper;

            $imageWrapper.set("href", get(data, "meta.link_to", null));
            $imageWrapper.setAttribute("title", i18nService.getString("app.ui.covers.ExternalCover.tooltip", {
                externalName: title
            }));

            sup.apply(this, arguments);
        };
    }),

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: function() {
        var $authService   = this.app.$.authService,
            $router        = this.app.$.router,
            data           = this.data || {},
            plan           = get(data, "plan", null),
            redirectPath,
            language       = this.app.$.i18nService.get("language"),
            userPrivileges =  $authService.getUserPrivileges();

        redirectPath = $router.getCurrentPath() || "";
        redirectPath = "/" + redirectPath.replace(/^\/+/, "");
        redirectPath = encodeURIComponent(redirectPath);

        if (plan === "premium") {
            if ($authService.isLoggedIn !== 1) {
                $router.redirect(quickMacroize("/{$language}/user-required/external/{$redirectPath}", {
                    language:     language,
                    redirectPath: redirectPath
                }));

                return true;
            }

            if (userPrivileges.userStatus !== "subscribed"
                || userPrivileges.subscriptionType !== "premium") {
                $router.redirect(quickMacroize("/{$language}/upgrade-required/{$redirectPath}", {
                    language:     language,
                    redirectPath: redirectPath
                }));

                return true;
            }
        }

        return onHyperlinkTap.apply(this, arguments);
    }

});
